/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React, { useEffect } from 'react'
import { Input, Form, Row, Col, Select } from 'antd'
const { Option } = Select

const PASSWORD_NOT_MATCH_MSG = 'Confirm password does not match'

const marketOptions = [
  { value: 'eMKT', text: 'eMKT' },
  { value: 'eFTR', text: 'eFTR' },
  { value: 'eDATAFEED', text: 'eDATAFEED' },
  { value: 'eSCHED', text: 'eSCHED' },
  { value: 'EES', text: 'EES' },
  { value: 'eMTR', text: 'eMTR' },
]

const ESuiteDetailsForm = props => {
  const {
    eSuiteFormRef,
    isNew = true,
    eSuite,
    editData,
    form,
    companyOption,
    resetPass = false,
    // setError,
  } = props

  const { getFieldDecorator, getFieldValue, validateFields } = form

  useEffect(() => {
    eSuiteFormRef.current = form
    // set form value incase of update, load time only
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const compareToFirstPassword = (rule, value, callback) => {
    if (value !== getFieldValue('password')) {
      callback(PASSWORD_NOT_MATCH_MSG)
    } else {
      callback()
    }
  }

  const validateToNextPassword = (rule, value, callback) => {
    if (value) {
      validateFields(['confirmPassword'], { force: true })
      callback()
    }
    callback()
  }

  const updateData = (property, value) => {
    editData(eSuite => ({ ...eSuite, [property]: value }))
  }

  return (
    <Form layout="vertical">
      <Row gutter={12}>
        <Col span={8}>
          <Form.Item label="Company :">
            {getFieldDecorator('company', {
              initialValue: eSuite.companyId || '',
              rules: [
                {
                  required: true,
                  message: 'Select Company Name',
                },
              ],
            })(
              <Select
                name="Company"
                disabled={!isNew}
                onChange={val => updateData('companyId', val)}
              >
                {companyOption.map(opt => (
                  <Option key={opt.value}>{opt.text}</Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="Market :">
            {getFieldDecorator('market', {
              initialValue: eSuite.market || marketOptions[0].value,
              rules: [
                {
                  required: true,
                  message: 'Select Market',
                },
              ],
            })(
              <Select
                name="Market"
                disabled={!isNew}
                onChange={val => updateData('market', val)}
              >
                {marketOptions.map(opt => (
                  <Option key={opt.value}>{opt.text}</Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="User Name : ">
            {getFieldDecorator('userName', {
              initialValue: eSuite.userName || '',
              rules: [{ required: true, message: 'Please Enter UserName' }],
            })(
              <Input
                disabled={!isNew}
                autoFocus
                placeholder="Enter User Name"
                name="userName"
                maxLength={30}
                onChange={e => updateData('userName', e.target.value)}
              />
            )}
          </Form.Item>
        </Col>
      </Row>
      {!resetPass && (
        <Row gutter={12}>
          <Col gutter={12}>
            <Form.Item label="Submit URL : ">
              {getFieldDecorator('submitUrl', {
                initialValue: eSuite.submitUrl || '',
                rules: [
                  {
                    required: true,
                    message: 'Enter valid Submit Url',
                  },
                ],
              })(
                <Input
                  placeholder="Enter Submit Url"
                  name="submitUrl"
                  onChange={e => updateData('submitUrl', e.target.value)}
                />
              )}
            </Form.Item>
          </Col>

          <Col gutter={12}>
            <Form.Item label="Query URL : ">
              {getFieldDecorator('queryUrl', {
                initialValue: eSuite.queryUrl || '',
                rules: [
                  {
                    required: true,
                    message: 'Enter valid Query Url',
                  },
                ],
              })(
                <Input
                  placeholder="Enter Query Url"
                  name="queryUrl"
                  onChange={e => updateData('queryUrl', e.target.value)}
                />
              )}
            </Form.Item>
          </Col>

          <Col gutter={12}>
            <Form.Item label="XMLNS : ">
              <Input
                placeholder="Enter XMLNS"
                name="xmlns"
                maxLength={60}
                value={eSuite.xmlns || ''}
                onChange={e => updateData('xmlns', e.target.value)}
              />
            </Form.Item>
          </Col>
        </Row>
      )}

      {(isNew || resetPass) && (
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item label="Password :">
              {getFieldDecorator('password', {
                initialValue: '',
                rules: [
                  { required: true, message: 'Please Enter the Password' },
                  {
                    validator: validateToNextPassword,
                  },
                ],
              })(
                <Input.Password
                  placeholder="Enter Password"
                  name="password"
                  onChange={e => updateData('password', e.target.value)}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Confirm Password :">
              {getFieldDecorator('confirmPassword', {
                initialValue: '',
                rules: [
                  {
                    validator: compareToFirstPassword,
                  },
                ],
              })(
                <Input.Password
                  placeholder="Confirm Temporary Password"
                  name="confirmPassword"
                />
              )}
            </Form.Item>
          </Col>
        </Row>
      )}
    </Form>
  )
}

export default Form.create({ name: 'eSuite_details' })(ESuiteDetailsForm)
